/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';

import Spinner from '@broadleaf/admin-components/dist/common/elements/Spinner';
import useFormatMessage from '@broadleaf/admin-components/dist/common/hooks/useFormatMessage';

import messages from './ItemBrowserGridLoading.messages';

const ItemBrowserGridLoading = props => {
  const formatMessage = useFormatMessage();
  return (
    <div className="ItemBrowserGridLoading tw-mt-52 tw-flex tw-w-full tw-items-center tw-justify-center tw-p-4 tw-text-center tw-text-xl tw-text-gray-500">
      <Spinner />
      {formatMessage(messages.loading)}
    </div>
  );
};

export default ItemBrowserGridLoading;
export { ItemBrowserGridLoading };
